<template>
  <v-card class="pa-3">
    <v-row no-gutters>
      <v-col cols="12" class="modal-header py-3 mb-2">
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="10">
            <span class="text-center text-lg d-block font-weight-medium w-full">علائم حیاتی</span>
          </v-col>
          <v-col cols="1" class="text-left mt-n2 ml-2">
            <v-icon color="darkColor" @click="closeDialog()">mdi-close</v-icon>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="ma-0 bodyItem" no-gutters>
      <v-col cols="12">
        <v-row class="ma-0">
          <v-col cols="4">
            <v-text-field type="text" outlined id="user-moveFromStationTime" ref="moveFromStationTime" dense clearable
              autocomplete="off" @click:clear="clearDateTime('observationDate')" clear-icon="mdi-close-circle-outline"
              v-model="tempObservationDate" @focus="showObservationDate = true" @click="showObservationDate = true"
              label="زمان گرفتن علائم حیاتی *" prepend-inner-icon="mdi-calendar-range mdi-18px">
              <template slot="append">
                <v-icon @click="showObservationDate = true" class="calender-background ml-n3 mt-n2" color="white">
                  mdi-calendar-range mdi-18px
                </v-icon>
              </template>
            </v-text-field>
            <date-picker :show="showObservationDate" simple :max="maxDateTime"
              v-model="patientVitalSign.observationDate" type="datetime" @open="onOpen"
              @change="dateTimeChange('observationDate')" :editable="true" format="YYYY-MM-DDTHH:mm:ss"
              display-format="HH:mm:ss jYYYY/jMM/jDD" custom-input="#moveFromStationTime-moveFromStationTime"
              @close="showObservationDate = false" />
          </v-col>
          <v-col cols="2">
            <v-text-field maxlength="2" :rules="[rulesTextInput.dard]" dense outlined @keypress="isNumber($event)"
              v-model="patientVitalSign.painScale" label="نمره درد" clearable clear-icon="mdi-close-circle-outline"
              prepend-inner-icon="mdi-counter mdi-18px"></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field maxlength="3" :rules="[rulesTextInput.dbp_sbp_pr]" dense outlined @keypress="isNumber($event)"
              v-model="patientVitalSign.diastolicBloodPressure" label="DBP" clearable
              clear-icon="mdi-close-circle-outline" prepend-inner-icon="mdi-counter mdi-18px"></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field maxlength="3" :rules="[rulesTextInput.dbp_sbp_pr]" dense outlined @keypress="isNumber($event)"
              v-model="patientVitalSign.systolicBloodPressure" label="SBP" clearable
              clear-icon="mdi-close-circle-outline" prepend-inner-icon="mdi-counter mdi-18px"></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field maxlength="3" :rules="[rulesTextInput.spO2]" dense outlined @keypress="isNumber($event)"
              v-model="patientVitalSign.spO2" label="SPO2" clearable clear-icon="mdi-close-circle-outline"
              prepend-inner-icon="mdi-counter mdi-18px"></v-text-field>
          </v-col>
          <v-col cols="2" class="mt-n5">
            <v-text-field maxlength="3" :rules="[rulesTextInput.bs]" dense outlined @keypress="isNumber($event)"
              v-model="patientVitalSign.bloodSugar" label="BS" clearable clear-icon="mdi-close-circle-outline"
              prepend-inner-icon="mdi-counter mdi-18px"></v-text-field>
          </v-col>
          <v-col cols="2" class="mt-n5">
            <v-text-field maxlength="3" :rules="[rulesTextInput.dbp_sbp_pr]" dense outlined @keypress="isNumber($event)"
              v-model="patientVitalSign.pulseRate" label="PR" clearable clear-icon="mdi-close-circle-outline"
              prepend-inner-icon="mdi-counter mdi-18px"></v-text-field>
          </v-col>

          <v-col cols="2" class="mt-n5">
            <v-text-field maxlength="2" :rules="[rulesTextInput.rr]" dense outlined @keypress="isNumber($event)"
              v-model="patientVitalSign.respiratoryRate" label="RR" clearable clear-icon="mdi-close-circle-outline"
              prepend-inner-icon="mdi-counter mdi-18px"></v-text-field>
          </v-col>
          <v-col cols="2" class="mt-n5">
            <v-text-field maxlength="4" :rules="[rulesTextInput.temp]" dense outlined @keypress="isNumber($event)"
              v-model="patientVitalSign.temperature" label="TEMP" clearable clear-icon="mdi-close-circle-outline"
              prepend-inner-icon="mdi-counter mdi-18px"></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row class="ma-0">
          <span>GCS</span>
          <v-divider class="mt-3 mr-3"></v-divider>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row class="ma-0">
          <v-col cols="4">
            <v-autocomplete :items="patientAge <= 5 ? openEyeTypeListUnder5 : openEyeTypeList"
              no-data-text="اطلاعاتی وجود ندارد" dense outlined item-text="title" item-value="id" label="باز کردن چشم"
              clearable return-object clear-icon="mdi-close-circle-outline" v-model="eye" autocomplete="off"
              prepend-inner-icon="mdi-account-eye mdi-18px"></v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-autocomplete :items="patientAge <= 5 ? voiceTypeListUnder5 : voiceTypeList"
              no-data-text="اطلاعاتی وجود ندارد" dense outlined item-text="title" item-value="id" label="کلامی"
              clearable return-object clear-icon="mdi-close-circle-outline" v-model="voice" autocomplete="off"
              prepend-inner-icon="mdi-account-voice mdi-18px"></v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-autocomplete :items="runTypeList" no-data-text="اطلاعاتی وجود ندارد" dense outlined item-text="title"
              item-value="id" label="حرکتی" clearable return-object clear-icon="mdi-close-circle-outline" v-model="run"
              autocomplete="off" prepend-inner-icon="mdi-run mdi-18px"></v-autocomplete>
          </v-col>
        </v-row>
      </v-col>
      <!-- <v-col cols="12">
        <v-row class="ma-0">
          <v-spacer></v-spacer>
          <v-btn rounded class="set-btn px-10 ml-2" text elevation="0" @click="goToStep5()">
            ثبت
          </v-btn>
        </v-row>
      </v-col> -->
      <v-col cols="12">

        <v-row class="ma-0 data-card-space">
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12" v-for="(item, index) in allVitalSigns" :key="index">
            <v-card class="info-list-card" elevation="0">
              <v-row class="covered-position mr-6">
                <span class="current-mission-header-content">علائم حیاتی {{ index + 1 }}</span>
              </v-row>
              <v-row class="ma-0" no-gutters>
                <v-col class="info-white-space">
                  <v-row class="ma-0">
                    <v-col cols="3" class="mt-5">
                      <v-row class=" mr-3">
                        <span class="info-items-title">GCS:</span>
                        <span class="mr-2">{{ item.gcs }}</span>
                      </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-5">
                      <v-row class="mr-3">
                        <span class="info-items-title">شاخص GAP:</span>
                        <span class="mr-2">{{ item.gap }}</span>
                      </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-5">
                      <v-row class="mr-3">
                        <span class="info-items-title">زمان گرفتن علائم حیاتی:</span>
                        <span class="mr-2">{{ item.time }}</span>
                      </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-5">
                      <v-row class="mr-3">
                        <span class="info-items-title">نمره درد:</span>
                        <span class="mr-2">{{ item.painScale }}</span>
                      </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-2">
                      <v-row class="mr-3">
                        <span class="info-items-title">SBP:</span>
                        <span class="mr-2">{{ item.sbp }}</span>
                      </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-2">
                      <v-row class="mr-3">
                        <span class="info-items-title">DBP:</span>
                        <span class="mr-2">{{ item.dbp }}</span>
                      </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-2">
                      <v-row class="mr-3">
                        <span class="info-items-title">SPO2:</span>
                        <span class="mr-2">{{ item.spo2 }}</span>
                      </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-2">
                      <v-row class="mr-3">
                        <span class="info-items-title">RR:</span>
                        <span class="mr-2">{{ item.rr }}</span>
                      </v-row>
                    </v-col>
                    <v-col cols="3" class="mb-3 mt-2">
                      <v-row class="mr-3">
                        <span class="info-items-title">TEMP:</span>
                        <span class="mr-2">{{ item.temp }}</span>
                      </v-row>
                    </v-col>
                    <v-col cols="3" class="mb-3 mt-2">
                      <v-row class="mr-3">
                        <span class="info-items-title">PR:</span>
                        <span class="mr-2">{{ item.pr }}</span>
                      </v-row>
                    </v-col>
                    <v-col cols="3" class="mb-3 mt-2">
                      <v-row class="mr-3">
                        <span class="info-items-title">BS:</span>
                        <span class="mr-2">{{ item.bs }}</span>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col class="info-action-space">
                  <v-row class="ma-0">
                    <v-spacer></v-spacer>
                    <v-icon class="mt-13" color="white" @click="deletePatientVitalSignFunction(item.id)">
                      mdi-trash-can
                    </v-icon>
                    <v-spacer></v-spacer>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <v-spacer></v-spacer>
      <v-btn rounded color="darkColor" dark @click="nextDialog()">ثبت و بعدی (علائم همراه)</v-btn>
      <v-btn rounded text class="set-btn mx-1" @click="goToStep5()">ثبت</v-btn>
      <v-btn text color="darkColor" @click="closeDialog()">بستن</v-btn>
    </v-row>
  </v-card>
</template>
<script>
import FollowUpPatientStep4Helper from '@/Helpers/FollowUp/FollowUpPatientPart/FollowUpPatientStep4Helper.js';
import SharedHelper from '@/Helpers/Shared';
import SharedMixin from '@/Mixins/Shared';
import PatientVitalSignMixin from '@/Mixins/FollowUp/FollowUpPatientPart/PatientVitalSignMixin.js';
import moment from 'moment';

export default {
  mixins: [FollowUpPatientStep4Helper, SharedHelper, SharedMixin, PatientVitalSignMixin],
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {
      isGoToNext: false,
      rulesTextInput: {
        dard: value => {
          if (value === '' || value === null || value === undefined) return true;
          const num = Number(value);
          if (isNaN(num)) return 'مقدار باید عدد باشد';
          if (num < 0) return 'مقدار باید بین ۰ تا ۱۰ باشد';
          if (num > 10) return 'مقدار باید بین ۰ تا ۱۰ باشد';
          return true;
        },
        bs: value => {
          if (value === '' || value === null || value === undefined) return true;
          const num = Number(value);
          if (isNaN(num)) return 'مقدار باید عدد باشد';
          if (num < 0) return 'مقدار باید بین ۰ تا ۷۰۰ باشد';
          if (num > 700) return 'مقدار باید بین ۰ تا ۷۰۰ باشد';
          return true;
        },
        rr: value => {
          if (value === '' || value === null || value === undefined) return true;
          const num = Number(value);
          if (isNaN(num)) return 'مقدار باید عدد باشد';
          if (num < 0) return 'مقدار باید بین ۰ تا ۶۰ باشد';
          if (num > 60) return 'مقدار باید بین ۰ تا ۶۰ باشد';
          return true;
        },
        dbp_sbp_pr: value => {
          if (value === '' || value === null || value === undefined) return true;
          const num = Number(value);
          if (isNaN(num)) return 'مقدار باید عدد باشد';
          if (num < 0) return 'مقدار باید بین ۰ تا ۳۰۰ باشد';
          if (num > 300) return 'مقدار باید بین ۰ تا ۳۰۰ باشد';
          return true;
        },
        temp: value => {
          if (value === '' || value === null || value === undefined) return true;
          const num = Number(value);
          if (isNaN(num)) return 'مقدار باید عدد باشد';
          if (num < 0) return 'مقدار باید بین ۰ تا ۴۴ باشد';
          if (num >= 44) return 'مقدار باید بین ۰ تا ۴۴ باشد';
          return true;
        },
        spO2: value => {
          if (value === '' || value === null || value === undefined) return true;
          const num = Number(value);
          if (isNaN(num)) return 'مقدار باید عدد باشد';
          if (num < 0) return 'مقدار باید بین ۰ تا ۱۰۰ باشد';
          if (num > 100) return 'مقدار باید بین ۰ تا ۱۰۰ باشد';
          return true;
        },
      },
    }
  },
  props: {
    patientId: {
      type: Number,
      require: true,
      default: null,
    },
    patientAge: {
      type: Number,
      require: true,
      default: null,
    },

  },
  methods: {
    mounte: function () {
      this.getAllPatientVitalSignFunction(this.patientId);
    },
    closeDialog() {
      this.$emit('reloadApiFun');
    },
    nextDialog() {
      // this.$emit('goToNextDialog');
      this.isGoToNext = true;
      this.$nextTick(() => {
        this.goToStep5();
      });
    },
  },
  computed: {
    maxDateTime() {
      return moment().format('YYYY-MM-DDTHH:mm:ss');
    }
  },
};
</script>
<style scoped>
.bodyItem {
  max-height: 575px !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

.info-text {
  color: #212121 !important;
}

.calender-background {
  background: #79747e;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 12px;
  padding-bottom: 12px;
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
}

.set-btn {
  background: var(--background-color) !important;
  color: var(--dark-color) !important;
  letter-spacing: normal !important;
  border: solid 1px var(--dark-color);
}

.data-card-space {
  /* height: 27vh !important; */
  height: 100%;
  overflow-y: auto;
}

.info-white-space {
  width: 100%;
  /* width: 95% !important;
  max-width: 95% !important;
  min-width: 95% !important; */
}

.info-action-space {
  width: 5% !important;
  max-width: 5% !important;
  min-width: 5% !important;
  background: var(--dark-color) !important;
  border-top-left-radius: 10px !important;
  border-bottom-left-radius: 10px !important;
}

.info-list-card {
  border: 1px solid var(--dark-color) !important;
  border-radius: 10px !important;
}

.current-mission-header-content {
  color: var(--dark-color) !important;
  background: white;
  padding-right: 20px !important;
  padding-left: 20px !important;
}

.covered-position {
  /* margin-top: -3vh !important; */
  position: absolute;
}

.info-items-title {
  font-size: 14px;
  font-weight: 600;
}
</style>
